import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

export const types = [
  'fl-post-item',
  'fl-repair-message',
  'fl-reservable-list-item',
  'fl-reservation-list-item',
  'fl-document',
  'fl-event-item',
  'fl-group-item',
  'fl-user-item',
  'group-member-item',
  'fl-invite-user-item'
] as const;

type Types = (typeof types)[number];

@Component({
  selector: 'bl-skeleton',
  imports: [CommonModule, IonicModule],
  templateUrl: './ui-skeleton.component.html',
  styleUrls: ['./ui-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiSkeletonComponent implements OnInit {
  @Input({ required: true }) type!: Types;

  @Input() count = 3;
  itemsToRender: number[] = [];

  ngOnInit(): void {
    this.itemsToRender = Array(this.count)
      .fill(0)
      .map((_, i) => i + 1);
  }
}
